import { format, isValid, parseISO } from 'date-fns';

export const isIsoDate = (value: string): boolean => {
  const date = parseISO(value);
  return /^\d{4}-\d{2}-\d{2}$/.test(value) && isValid(date) && format(date, 'yyyy-MM-dd') === value;
};

// Backend's configured calendar is UTC. Keep date-only picker values in the local calendar.
export const getDsarDateLimits = (now = new Date()) => ({
  today: now.toISOString().slice(0, 10),
  maximumDueDate: new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 90)).toISOString().slice(0, 10),
});

export const toPickerDate = (value: string): Date | null => (value ? parseISO(value) : null);
export const fromPickerDate = (value: Date | null): string => {
  if (!value) return '';
  return isValid(value) ? format(value, 'yyyy-MM-dd') : 'invalid';
};
